import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
  },
})
export default class VCustomSelect extends Vue {
  @Prop()
  value: any;
  @Prop()
  id: any;
  @Prop()
  dataCy: any;
  @Prop()
  name: any;
  @Prop()
  itemText: any;
  @Prop()
  itemValue: any;
  @Prop()
  items: any;
  @Prop()
  errorMessages: any;
  @Prop()
  label: any;
  @Prop({ default: false })
  dense: boolean;
  @Prop({ default: false })
  outlined: boolean;
  @Prop({ default: false })
  required: boolean;
  @Prop({ default: false })
  readonly: boolean;
  @Prop({ default: false })
  returnObject: boolean;
  @Prop({ default: false })
  disabled: boolean;
  @Prop({ default: false })
  hideDetails: boolean;
  @Prop()
  appendIcon: any;
  @Prop()
  menuProps: any;
  @Prop()
  singleLine: false;
  @Prop()
  itemDisabled: false;
  @Prop()
  placeholder: any;

  mounted(): void {
    const el = document.querySelector('#app-identifier');
    el.addEventListener('scroll', this.handleScroll);
  }

  beforeDestroy(): void {
    const el = document.querySelector('#app-identifier');
    if (el) {
      el.removeEventListener('scroll', this.handleScroll);
    }
  }

  public handleScroll() {
    const shopRef = this.$refs[this.id] as Vue & { isMenuActive: boolean };
    shopRef.isMenuActive = false;
  }

  public generateIdentifer(item) {
    return this.id + '-' + this.items.indexOf(item);
  }

  public findDisplayName(item) {
    const keys = ['name', 'saneName', 'text'];
    const key = Object.keys(item).find(key => keys.includes(key));
    if (key) {
      return item[key];
    }
    return item;
  }
}
